function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { FilterButtons, slugify } from './configs';
import Button from '@profile/src/Components/Button_V2';
import { useTestId } from '@wolffun/testable-id';

const HeaderTab = ({
  status,
  onChange
}) => {
  const {
    generateTestIdProps
  } = useTestId();

  const renderButton = ({
    buttonTitle,
    buttonStatus,
    dataTestId
  }) => {
    return /*#__PURE__*/React.createElement(Button, _extends({
      key: buttonStatus
    }, generateTestIdProps(dataTestId), {
      className: classNames(styles.button, status.toString() === buttonStatus.toString() && styles.active),
      onClick: () => onChange(buttonStatus),
      title: buttonTitle
    }));
  };

  const renderContent = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderButton({
      buttonTitle: 'All',
      buttonStatus: 'all',
      dataTestId: 'all'
    }), // Since we define filter button type as CosmeticType(an enum object) | 'all', the order of FilterButton object's property will order by number first, something like {1: 'Foo',2: 'Bar',...,'all': 'All'}
    // but we need to render the 'All' button first, so we have to render it separately with renderButton above, and below is the code to render the rest of enum CosmeticType
    Object.keys(FilterButtons).map(status => status !== 'all' && renderButton({
      buttonTitle: FilterButtons[status],
      buttonStatus: status,
      dataTestId: slugify(FilterButtons[status])
    })));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, renderContent());
};

export default HeaderTab;